import React, { FC } from 'react';

const FoodoraDepartment: FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      width="200"
      height="200"
      viewBox="0 0 200 200"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M134.319 169.72H66.0394C49.7194 169.72 36.3994 156.44 36.3994 140.08V71.84C36.3994 55.52 49.6794 42.2 66.0394 42.2H134.279C150.599 42.2 163.919 55.48 163.919 71.84V140.08C163.919 156.44 150.639 169.72 134.319 169.72Z"
        fill="#EFF2F4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M111.404 169.72H134.319C138.311 169.72 142.121 168.925 145.599 167.486V73.3697C145.599 66.9408 140.469 61.6808 134.199 61.6808H65.7994C59.5294 61.6808 54.3994 66.9408 54.3994 73.3697V167.337C57.9762 168.87 61.9119 169.72 66.0394 169.72H88.5944C88.5977 169.626 88.5994 169.532 88.5994 169.436V149.347C88.5994 145.841 90.8794 143.503 94.2994 143.503H105.699C109.119 143.503 111.399 145.841 111.399 149.347V169.436C111.399 169.532 111.401 169.626 111.404 169.72ZM94.2994 111.359C94.2994 109.605 93.1594 108.436 91.4494 108.436H85.7494C84.0394 108.436 82.8994 109.605 82.8994 111.359V117.203C82.8994 118.956 84.0394 120.125 85.7494 120.125H91.4494C93.1594 120.125 94.2994 118.956 94.2994 117.203V111.359ZM117.099 111.359C117.099 109.605 115.959 108.436 114.249 108.436H108.549C106.839 108.436 105.699 109.605 105.699 111.359V117.203C105.699 118.956 106.839 120.125 108.549 120.125H114.249C115.959 120.125 117.099 118.956 117.099 117.203V111.359ZM94.2994 87.9808C94.2994 86.2274 93.1594 85.0586 91.4494 85.0586H85.7494C84.0394 85.0586 82.8994 86.2274 82.8994 87.9808V93.8252C82.8994 95.5785 84.0394 96.7474 85.7494 96.7474H91.4494C93.1594 96.7474 94.2994 95.5785 94.2994 93.8252V87.9808ZM117.099 87.9808C117.099 86.2274 115.959 85.0586 114.249 85.0586H108.549C106.839 85.0586 105.699 86.2274 105.699 87.9808V93.8252C105.699 95.5785 106.839 96.7474 108.549 96.7474H114.249C115.959 96.7474 117.099 95.5785 117.099 93.8252V87.9808Z"
        fill="#DF1067"
      />
      <path
        d="M91.4494 85.0586C93.1594 85.0586 94.2994 86.2274 94.2994 87.9808V93.8252C94.2994 95.5785 93.1594 96.7474 91.4494 96.7474H85.7494C84.0394 96.7474 82.8994 95.5785 82.8994 93.8252V87.9808C82.8994 86.2274 84.0394 85.0586 85.7494 85.0586H91.4494Z"
        fill="white"
      />
      <path
        d="M114.249 85.0586C115.959 85.0586 117.099 86.2274 117.099 87.9808V93.8252C117.099 95.5785 115.959 96.7474 114.249 96.7474H108.549C106.839 96.7474 105.699 95.5785 105.699 93.8252V87.9808C105.699 86.2274 106.839 85.0586 108.549 85.0586H114.249Z"
        fill="white"
      />
      <path
        d="M114.249 108.436C115.959 108.436 117.099 109.605 117.099 111.359V117.203C117.099 118.956 115.959 120.125 114.249 120.125H108.549C106.839 120.125 105.699 118.956 105.699 117.203V111.359C105.699 109.605 106.839 108.436 108.549 108.436H114.249Z"
        fill="white"
      />
      <path
        d="M91.4494 108.436C93.1594 108.436 94.2994 109.605 94.2994 111.359V117.203C94.2994 118.956 93.1594 120.125 91.4494 120.125H85.7494C84.0394 120.125 82.8994 118.956 82.8994 117.203V111.359C82.8994 109.605 84.0394 108.436 85.7494 108.436H91.4494Z"
        fill="white"
      />
      <path
        d="M123.597 145.28C123.597 135.96 131.157 128.4 140.477 128.4C149.797 128.4 157.357 135.96 157.357 145.28C157.357 154.6 149.797 162.16 140.477 162.16C131.157 162.16 123.597 154.6 123.597 145.28Z"
        fill="#0A4342"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M130.706 145.2C130.706 144.244 131.481 143.469 132.437 143.469H148.157C149.112 143.469 149.887 144.244 149.887 145.2C149.887 146.156 149.112 146.93 148.157 146.93H132.437C131.481 146.93 130.706 146.156 130.706 145.2Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M140.314 135.789C141.27 135.789 142.045 136.564 142.045 137.52V153.28C142.045 154.236 141.27 155.01 140.314 155.01C139.359 155.01 138.584 154.236 138.584 153.28V137.52C138.584 136.564 139.359 135.789 140.314 135.789Z"
        fill="white"
      />
    </svg>
  );
};

export default FoodoraDepartment;
